/**
 * Device model slugs — compatibility groups for MBF, PDP picker, recent chips, search.
 * Keep SLUG_ALIASES in sync with utils/funcs.py MODEL_SLUG_ALIASES.
 */
(function (window) {
  'use strict';

  var DEFAULT_FILTER_PARAM = 'filter.v.m.custom.compatible_model';
  var USER_MODEL_PARAM = 'aioo_model';

  var SLUG_ALIASES = {
    'iphone 17 air': 'iphone air',
    '17 air': 'iphone air',
    'iphone se 2020': 'iphone se 20',
    'iphone se 2022': 'iphone se 22',
    'iphone se 2025': 'iphone se 22',
    'iphone x': 'iphone x/xs',
    'iphone xs': 'iphone x/xs',
    'iphone xs/x': 'iphone x/xs',
    'galaxy a13 5g': 'galaxy a13',
    'galaxy a14 5g': 'galaxy a14',
    'galaxy a15 5g': 'galaxy a15',
    'galaxy a22 5g': 'galaxy a22',
    'galaxy a23 5g': 'galaxy a23',
    'galaxy a25 5g': 'galaxy a25',
    'galaxy a26 5g': 'galaxy a26',
    'galaxy a32 5g': 'galaxy a32',
    'galaxy a33 5g': 'galaxy a33',
    'galaxy a34 5g': 'galaxy a34',
    'galaxy a35 5g': 'galaxy a35',
    'galaxy a36 5g': 'galaxy a36',
    'galaxy a42 5g': 'galaxy a42',
    'galaxy a51 5g': 'galaxy a51',
    'galaxy a52 5g': 'galaxy a52',
    'galaxy a53 5g': 'galaxy a53',
    'galaxy a54 5g': 'galaxy a54',
    'galaxy a55 5g': 'galaxy a55',
    'galaxy a56 5g': 'galaxy a56',
    'galaxy a71 5g': 'galaxy a71',
    'galaxy a72 5g': 'galaxy a72',
    'galaxy a22 4g': 'galaxy a22',
    'galaxy a10s': 'galaxy a10',
    'galaxy a21s': 'galaxy a21',
    'galaxy a50s': 'galaxy a50',
    'galaxy a70s': 'galaxy a70',
    'galaxy a52s 5g': 'galaxy a52',
    'galaxy a70 / a70s': 'galaxy a70',
    'galaxy a52 / a52 5g / a52s 5g': 'galaxy a52',
    'galaxy flip 6': 'galaxy z flip 6',
    'galaxy fold 6': 'galaxy z fold 6',
    'galaxy z flip 3 5g': 'galaxy z flip 3',
    'galaxy z flip 5 5g': 'galaxy z flip 5',
    'galaxy z fold 3 5g': 'galaxy z fold 3',
    'galaxy z fold 5 5g': 'galaxy z fold 5',
    'galaxy watch 40/42/44/46mm': 'galaxy watch 40/42/44/45/46mm',
    'poco m3 pro 5g': 'poco m3 pro',
    'mi 11 lite 5g': 'mi 11 lite',
    'mi 11 lite 5g ne': 'mi 11 lite 5g',
    'redmi mi 11 lite': 'mi 11 lite',
    'redmi mi 11 lite 5g': 'mi 11 lite 5g',
    'redmi mi 11 lite 5g ne': 'mi 11 lite 5g ne',
    'mi mi 11 lite 5g': 'mi 11 lite 5g',
    '11s 5g': 'redmi 11s 5g',
    'redmi 13 5g': 'redmi 13',
  };

  var SEARCH_SYNONYMS = {
    '17 air': ['iphone air', 'iphone 17 air'],
    'iphone 17 air': ['iphone air'],
    'iphone air': ['iphone 17 air', '17 air'],
    'se 2020': ['iphone se 20', 'iphone se 2020'],
    'se 2022': ['iphone se 22', 'iphone se 2022'],
    'iphone x': ['iphone x/xs', 'iphone xs'],
    'iphone xs': ['iphone x/xs', 'iphone x'],
    'x/xs': ['iphone x/xs'],
    'xs/x': ['iphone x/xs'],
    'galaxy a72 5g': ['galaxy a72'],
    'galaxy a71 5g': ['galaxy a71'],
    'galaxy a55 5g': ['galaxy a55'],
    'galaxy a70s': ['galaxy a70'],
    'galaxy a50s': ['galaxy a50'],
    'galaxy a30s': ['galaxy a50', 'galaxy a50s'],
    'galaxy flip 6': ['galaxy z flip 6'],
    'galaxy fold 6': ['galaxy z fold 6'],
  };

  /* Models whose accessories fit another model unchanged: kind (case | glass) -> native slug ->
     models it also fits. Mirror of utils/compat_aliases.py COMPAT_ALIASES (tests/test_compat_aliases.py
     fails when they drift: keep it plain JSON). The catalog already carries both models in
     custom.compatible_model; this table only lets the PDP model picker offer the alias model as a
     real choice. Not part of the union-find groups below on purpose: the alias model stays its own
     filter entry. */
  var COMPAT_ALIASES = {
    "case": {
      "iphone 12": [
        "iphone 12 pro"
      ],
      "iphone 12 pro": [
        "iphone 12"
      ],
      "iphone 13": [
        "iphone 14"
      ],
      "iphone 17 pro": [
        "iphone 18 pro"
      ],
      "iphone 17 pro max": [
        "iphone 18 pro max"
      ],
      "iphone 6 plus": [
        "iphone 7 plus",
        "iphone 8 plus",
        "iphone 6s plus"
      ],
      "iphone 6s plus": [
        "iphone 7 plus",
        "iphone 8 plus",
        "iphone 6 plus"
      ],
      "iphone 7": [
        "iphone 8",
        "iphone se 20",
        "iphone se 22"
      ],
      "iphone 7 plus": [
        "iphone 8 plus",
        "iphone 6 plus",
        "iphone 6s plus"
      ],
      "iphone 8": [
        "iphone 7",
        "iphone se 20",
        "iphone se 22"
      ],
      "iphone 8 plus": [
        "iphone 7 plus",
        "iphone 6 plus",
        "iphone 6s plus"
      ],
      "iphone se 20": [
        "iphone 7",
        "iphone 8",
        "iphone se 22"
      ],
      "iphone se 22": [
        "iphone 7",
        "iphone 8",
        "iphone se 20"
      ]
    },
    "glass": {
      "galaxy a14": [
        "galaxy a24"
      ],
      "galaxy a24": [
        "galaxy a14"
      ],
      "galaxy a52": [
        "galaxy a53"
      ],
      "galaxy a53": [
        "galaxy a52"
      ],
      "galaxy a54": [
        "galaxy s23 fe"
      ],
      "galaxy s23 fe": [
        "galaxy a54"
      ],
      "iphone 11": [
        "iphone xr"
      ],
      "iphone 11 pro": [
        "iphone x/xs"
      ],
      "iphone 11 pro max": [
        "iphone xs max"
      ],
      "iphone 12": [
        "iphone 12 pro"
      ],
      "iphone 12 pro": [
        "iphone 12"
      ],
      "iphone 13": [
        "iphone 13 pro",
        "iphone 14",
        "iphone 16e",
        "iphone 17e"
      ],
      "iphone 13 pro": [
        "iphone 13",
        "iphone 14",
        "iphone 16e",
        "iphone 17e"
      ],
      "iphone 13 pro max": [
        "iphone 14 plus"
      ],
      "iphone 14": [
        "iphone 13",
        "iphone 13 pro",
        "iphone 16e",
        "iphone 17e"
      ],
      "iphone 14 plus": [
        "iphone 13 pro max"
      ],
      "iphone 14 pro": [
        "iphone 15",
        "iphone 16"
      ],
      "iphone 15": [
        "iphone 14 pro",
        "iphone 16"
      ],
      "iphone 16": [
        "iphone 14 pro",
        "iphone 15"
      ],
      "iphone 16e": [
        "iphone 13",
        "iphone 13 pro",
        "iphone 14",
        "iphone 17e"
      ],
      "iphone 17 pro": [
        "iphone 18 pro"
      ],
      "iphone 17 pro max": [
        "iphone 18 pro max"
      ],
      "iphone 17e": [
        "iphone 13",
        "iphone 13 pro",
        "iphone 14",
        "iphone 16e"
      ],
      "iphone 7": [
        "iphone 8"
      ],
      "iphone 7 plus": [
        "iphone 8 plus"
      ],
      "iphone 8": [
        "iphone 7"
      ],
      "iphone 8 plus": [
        "iphone 7 plus"
      ],
      "iphone x/xs": [
        "iphone 11 pro"
      ],
      "iphone xr": [
        "iphone 11"
      ],
      "iphone xs max": [
        "iphone 11 pro max"
      ]
    }
  };

  var WORD_MAP = {
    iphone: 'iPhone', galaxy: 'Galaxy', samsung: 'Samsung',
    xiaomi: 'Xiaomi', redmi: 'Redmi', poco: 'Poco', mi: 'Mi',
    pixel: 'Pixel', google: 'Google', huawei: 'Huawei', honor: 'Honor',
    nokia: 'Nokia', realme: 'Realme', oneplus: 'OnePlus',
    airpods: 'AirPods', ipad: 'iPad', macbook: 'MacBook', apple: 'Apple',
    pro: 'Pro', max: 'Max', plus: 'Plus', mini: 'Mini', ultra: 'Ultra',
    se: 'SE', air: 'Air', lite: 'Lite', fe: 'FE', '5g': '5G', nfc: 'NFC',
    edge: 'Edge', note: 'Note', fold: 'Fold', flip: 'Flip', neo: 'Neo',
    xr: 'XR', xs: 'XS', xcover: 'Xcover', '4g': '4G', gen: 'Gen',
    watch: 'Watch', tab: 'Tab',
  };

  var BRAND_PREFIXES = [
    'galaxy', 'iphone', 'apple watch', 'galaxy watch', 'redmi', 'xiaomi',
    'poco', 'huawei', 'honor', 'pixel', 'airpods', 'mi',
  ];

  var SEED_SLUGS = [
    'galaxy a10', 'galaxy a10s', 'galaxy a21', 'galaxy a21s', 'galaxy a30s',
    'galaxy a50', 'galaxy a50s', 'galaxy a70', 'galaxy a70s',
    'galaxy a30s / a50 / a50s', 'galaxy a70 / a70s',
    'galaxy a52', 'galaxy a52 5g', 'galaxy a52s 5g', 'galaxy a52 / a52 5g / a52s 5g',
    'galaxy watch 40mm', 'galaxy watch 44mm', 'galaxy watch 45mm', 'galaxy watch 46mm',
    'galaxy watch 40/42/44/45/46mm', 'galaxy watch 40/42/44/46mm',
    'apple watch 40mm', 'apple watch 41mm', 'apple watch 44mm', 'apple watch 45mm',
    'apple watch 38/40/41mm', 'apple watch 42/44/45mm',
    'iphone air', 'iphone 17 air', 'iphone x/xs', 'iphone x', 'iphone xs', 'iphone xs/x',
    'iphone 7', 'iphone 8', 'iphone 7 plus', 'iphone 8 plus',
    'iphone se 20', 'iphone se 22',
    'iphone 7 / 8 / se 20 / se 22', 'iphone 7 plus / 8 plus', 'iphone 12/12 pro',
    'airpods 1/2', 'huawei p30 pro / pro+',
    'redmi note 11 / 11s', 'redmi 9a / 9at / 9i', 'redmi note 9 pro / pro max / s',
    'redmi 13t / 13t pro',
    'mi 11 lite', 'mi 11 lite 5g', 'mi 11 lite 5g ne',
    'mi 11 lite / mi 11 lite 5g / mi 11 lite 5g ne',
    'poco m3 pro', 'poco m3 pro 5g',
    'redmi 13', 'redmi 13 5g',
  ];

  var ufParent = {};
  var ufRank = {};
  var COMPATIBILITY_GROUPS = {};
  var DYNAMIC_SLUGS = [];

  function normSlug(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function ufFind(x) {
    if (!ufParent[x]) ufParent[x] = x;
    if (ufParent[x] !== x) ufParent[x] = ufFind(ufParent[x]);
    return ufParent[x];
  }

  function ufUnion(a, b) {
    if (!a || !b || a === b) return;
    var ra = ufFind(a);
    var rb = ufFind(b);
    if (ra === rb) return;
    if (!ufRank[ra]) ufRank[ra] = 0;
    if (!ufRank[rb]) ufRank[rb] = 0;
    if (ufRank[ra] < ufRank[rb]) {
      ufParent[ra] = rb;
    } else if (ufRank[ra] > ufRank[rb]) {
      ufParent[rb] = ra;
    } else {
      ufParent[rb] = ra;
      ufRank[ra] += 1;
    }
  }

  function ufLinkAll(slugs) {
    var uniq = [];
    var seen = {};
    (slugs || []).forEach(function (s) {
      var n = normSlug(s);
      if (!n || seen[n]) return;
      seen[n] = true;
      uniq.push(n);
      if (!ufParent[n]) ufParent[n] = n;
    });
    if (uniq.length < 2) return uniq;
    for (var i = 1; i < uniq.length; i++) ufUnion(uniq[0], uniq[i]);
    return uniq;
  }

  function hasBrandPrefix(slug) {
    var s = normSlug(slug);
    for (var i = 0; i < BRAND_PREFIXES.length; i++) {
      if (s.indexOf(BRAND_PREFIXES[i] + ' ') === 0 || s === BRAND_PREFIXES[i]) return true;
    }
    return false;
  }

  function inferPrefix(firstPart) {
    var s = normSlug(firstPart);
    if (!s) return '';
    var sorted = BRAND_PREFIXES.slice().sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < sorted.length; i++) {
      var bp = sorted[i];
      if (s === bp || s.indexOf(bp + ' ') === 0) return bp + ' ';
    }
    var tokens = s.split(' ');
    if (tokens.length < 2) return '';
    return tokens.slice(0, -1).join(' ') + ' ';
  }

  function parseWatchSizeCombo(slug) {
    var s = normSlug(slug);
    var m = s.match(/^(galaxy watch|apple watch)\s+([\d/]+mm)$/i);
    if (!m) return null;
    var prefix = m[1];
    var rest = m[2];
    if (rest.indexOf('/') === -1) return null;
    var members = [s];
    var chunks = rest.split('/');
    chunks.forEach(function (chunk) {
      chunk = chunk.replace(/\s+/g, '').trim();
      if (!chunk) return;
      if (chunk.indexOf('mm') === -1) chunk += 'mm';
      members.push(prefix + ' ' + chunk);
    });
    return members;
  }

  function parseComboSlug(slug) {
    var s = normSlug(slug);
    if (!s) return [];

    var watchMembers = parseWatchSizeCombo(s);
    if (watchMembers) return watchMembers;

    if (s.indexOf(' / ') === -1 && s.indexOf(',') === -1) return [s];

    var parts = s.split(/\s*\/\s*|\s*,\s*/).map(normSlug).filter(Boolean);
    if (parts.length < 2) return [s];

    var members = [s];
    var prefix = inferPrefix(parts[0]);

    parts.forEach(function (part, idx) {
      if (idx === 0) {
        members.push(part);
        return;
      }
      if (hasBrandPrefix(part)) {
        members.push(part);
      } else if (prefix) {
        members.push(normSlug(prefix + part));
      } else {
        members.push(part);
      }
    });

    return members;
  }

  /**
   * Find live facet values (comma/slash combo strings, e.g. a universal
   * cable tagged "iphone 13,iphone 14,iphone 16e") whose split membership
   * includes slug. Used to ADD a combo's count/URL to every model it
   * actually contains, without registering the combo into the global
   * union-find groups — that would wrongly treat unrelated models tagged
   * together on one generic accessory as permanently interchangeable
   * everywhere on the site.
   */
  function collectComboContributions(slug, facetSlugList) {
    var out = [];
    (facetSlugList || []).forEach(function (facetSlug) {
      if (facetSlug === slug) return;
      if (facetSlug.indexOf(',') === -1 && facetSlug.indexOf(' / ') === -1) return;
      var members = parseComboSlug(facetSlug);
      for (var i = 1; i < members.length; i++) {
        if (members[i] === slug) { out.push(facetSlug); return; }
      }
    });
    return out;
  }

  function registerSlug(slug) {
    var s = normSlug(slug);
    if (!s) return;
    if (!ufParent[s]) ufParent[s] = s;
    ufLinkAll(parseComboSlug(s));
  }

  function rebuildCompatibilityGroups() {
    ufParent = {};
    ufRank = {};
    COMPATIBILITY_GROUPS = {};

    SEED_SLUGS.forEach(registerSlug);
    DYNAMIC_SLUGS.forEach(registerSlug);
    Object.keys(SLUG_ALIASES).forEach(function (alias) {
      registerSlug(alias);
      registerSlug(SLUG_ALIASES[alias]);
      ufLinkAll([alias, SLUG_ALIASES[alias]]);
    });

    var roots = {};
    Object.keys(ufParent).forEach(function (slug) {
      var root = ufFind(slug);
      if (!roots[root]) roots[root] = {};
      roots[root][slug] = true;
    });

    Object.keys(roots).forEach(function (root) {
      var group = Object.keys(roots[root]).sort();
      group.forEach(function (slug) {
        COMPATIBILITY_GROUPS[slug] = group;
      });
    });
  }

  rebuildCompatibilityGroups();

  function registerCompatibilitySlugs(slugs) {
    var changed = false;
    (slugs || []).forEach(function (slug) {
      var n = normSlug(slug);
      if (!n || DYNAMIC_SLUGS.indexOf(n) !== -1) return;
      DYNAMIC_SLUGS.push(n);
      changed = true;
    });
    if (changed) rebuildCompatibilityGroups();
  }

  function getCompatibilityGroup(slug) {
    var s = normSlug(slug);
    if (!s) return [];
    if (COMPATIBILITY_GROUPS[s]) return COMPATIBILITY_GROUPS[s].slice();
    if (DYNAMIC_SLUGS.indexOf(s) === -1) DYNAMIC_SLUGS.push(s);
    rebuildCompatibilityGroups();
    return COMPATIBILITY_GROUPS[s] ? COMPATIBILITY_GROUPS[s].slice() : [s];
  }

  function expandSlugForFilter(slug) {
    return getCompatibilityGroup(slug);
  }

  function slugsInSameGroup(a, b) {
    if (!a || !b) return false;
    if (normSlug(a) === normSlug(b)) return true;
    var ga = getCompatibilityGroup(a);
    var nb = normSlug(b);
    for (var i = 0; i < ga.length; i++) {
      if (ga[i] === nb) return true;
    }
    return false;
  }

  function normalizeModelSlug(raw) {
    var s = normSlug(raw);
    if (!s) return '';
    return SLUG_ALIASES[s] || s;
  }

  function allSlugsForCanonical(canon) {
    return getCompatibilityGroup(canon);
  }

  function modelsMatch(a, b) {
    return slugsInSameGroup(a, b);
  }

  function modelMatchesSearch(modelSlug, modelLabel, query) {
    var q = normSlug(query);
    if (!q) return true;
    var raw = normSlug(modelSlug);
    var text = normSlug(modelLabel);
    if (raw.indexOf(q) !== -1 || text.indexOf(q) !== -1) return true;
    if (slugsInSameGroup(raw, q)) return true;
    if (q.indexOf('galaxy ') !== 0 && /^a\d/.test(q)) {
      if (slugsInSameGroup('galaxy ' + q, raw)) return true;
    }
    var syns = SEARCH_SYNONYMS[q] || [];
    for (var i = 0; i < syns.length; i++) {
      if (raw.indexOf(syns[i]) !== -1 || text.indexOf(syns[i]) !== -1) return true;
      if (slugsInSameGroup(raw, syns[i])) return true;
    }
    if (q.indexOf('17') !== -1 && q.indexOf('air') !== -1 && slugsInSameGroup(raw, 'iphone air')) {
      return true;
    }
    if (slugsInSameGroup(raw, 'iphone x/xs')) {
      if (q === 'x' || q === 'xs' || q.indexOf('x/xs') !== -1 || q.indexOf('xs/x') !== -1) {
        return true;
      }
    }
    return false;
  }

  function formatModelLabel(slug) {
    var raw = normSlug(slug);
    if (!raw) return '';
    if (raw === 'iphone air' || raw === 'iphone 17 air') return 'iPhone Air';
    if (raw === 'iphone 16e') return 'iPhone 16e';
    if (raw === 'iphone x/xs' || raw === 'iphone xs/x') return 'iPhone X/XS';
    return raw.split(' ').map(function (w) {
      if (w === '/') return '/';
      var lw = w.toLowerCase();
      if (/^\d+e$/i.test(w)) return w.slice(0, -1) + 'E';
      return WORD_MAP[lw] || (w.charAt(0).toUpperCase() + w.slice(1));
    }).join(' ').replace(/\s+\/\s+/g, ' / ');
  }

  function canonicalFacetSlug(slug) {
    var s = normSlug(slug);
    return SLUG_ALIASES[s] || s;
  }

  function loadFacetCounts(root) {
    var map = {};
    if (!root) return map;
    var raw = root.getAttribute('data-mbf-facets');
    if (!raw) {
      var scriptEl = root.querySelector('script.mbf-facet-data');
      if (scriptEl) raw = scriptEl.textContent;
    }
    if (!raw) return map;
    try {
      var parsed = JSON.parse(raw);
      Object.keys(parsed).forEach(function (key) {
        var c = parseInt(parsed[key], 10);
        if (!c || c < 0) return;
        var n = normSlug(key);
        var canon = canonicalFacetSlug(n);
        map[n] = Math.max(map[n] || 0, c);
        map[canon] = Math.max(map[canon] || 0, c);
      });
    } catch (_e) { /* ignore */ }
    return map;
  }

  function getUserModelFromUrl(urlObj) {
    try {
      var u = urlObj || new URL(window.location.href);
      var val = u.searchParams.get(USER_MODEL_PARAM);
      return val ? normSlug(val) : '';
    } catch (_e) {
      return '';
    }
  }

  function setUserModelParam(urlObj, slug) {
    var s = normSlug(slug);
    if (!s) {
      urlObj.searchParams.delete(USER_MODEL_PARAM);
      return;
    }
    urlObj.searchParams.set(USER_MODEL_PARAM, s);
  }

  function readStoredUserModel(storageKey) {
    storageKey = storageKey || 'AIOO_selectedDevice';
    try {
      return normSlug(localStorage.getItem(storageKey) || '');
    } catch (_e) {
      return '';
    }
  }

  function resolveUserDisplayModel(urlObj, filterParam, storageKey) {
    filterParam = filterParam || DEFAULT_FILTER_PARAM;
    var activeSlugs = getActiveFilterSlugs(filterParam);
    if (!activeSlugs.length) return '';

    var fromParam = getUserModelFromUrl(urlObj);
    if (fromParam && isGroupActive(expandSlugForFilter(fromParam), activeSlugs)) {
      return canonicalFacetSlug(fromParam);
    }

    var fromStorage = readStoredUserModel(storageKey);
    if (fromStorage && isGroupActive(expandSlugForFilter(fromStorage), activeSlugs)) {
      return canonicalFacetSlug(fromStorage);
    }

    var candidates = activeSlugs.filter(function (s) {
      return !isComboDisplaySlug(s);
    });
    if (!candidates.length) candidates = activeSlugs.slice();
    candidates.sort(function (a, b) {
      if (a.length !== b.length) return a.length - b.length;
      return a.localeCompare(b);
    });
    return canonicalFacetSlug(candidates[0]);
  }

  function buildFilterAddHref(baseHref, slugs, filterParam) {
    filterParam = filterParam || DEFAULT_FILTER_PARAM;
    try {
      var u = new URL(baseHref, window.location.origin);
      u.searchParams.delete(filterParam);
      var seen = {};
      slugs.forEach(function (s) {
        var n = normSlug(s);
        if (!n || seen[n]) return;
        seen[n] = true;
        u.searchParams.append(filterParam, n);
      });
      return u.pathname + u.search + (u.hash || '');
    } catch (_e) {
      return baseHref;
    }
  }

  function buildFilterRemoveHref(baseHref, slugs, filterParam) {
    filterParam = filterParam || DEFAULT_FILTER_PARAM;
    try {
      var u = new URL(baseHref, window.location.origin);
      var remove = {};
      slugs.forEach(function (s) {
        remove[normSlug(s)] = true;
      });
      var kept = [];
      u.searchParams.forEach(function (val, key) {
        if (key === filterParam && remove[normSlug(val)]) return;
        kept.push([key, val]);
      });
      var nu = new URL(u.pathname, window.location.origin);
      kept.forEach(function (pair) {
        nu.searchParams.append(pair[0], pair[1]);
      });
      var stillHasModelFilter = false;
      nu.searchParams.forEach(function (_val, key) {
        if (key.indexOf('compatible_model') !== -1) stillHasModelFilter = true;
      });
      if (!stillHasModelFilter) nu.searchParams.delete(USER_MODEL_PARAM);
      return nu.pathname + nu.search + (u.hash || '');
    } catch (_e) {
      return baseHref;
    }
  }

  function getActiveFilterSlugs(filterParam) {
    filterParam = filterParam || DEFAULT_FILTER_PARAM;
    var out = [];
    var seen = {};
    try {
      var u = new URL(window.location.href);
      u.searchParams.forEach(function (val, key) {
        if (key !== filterParam) return;
        var n = normSlug(val);
        if (!n || seen[n]) return;
        seen[n] = true;
        out.push(n);
      });
    } catch (_e) { /* ignore */ }
    return out;
  }

  function isGroupActive(groupSlugs, activeSlugs) {
    if (!activeSlugs.length || !groupSlugs.length) return false;
    var active = {};
    activeSlugs.forEach(function (s) { active[s] = true; });
    for (var i = 0; i < groupSlugs.length; i++) {
      if (active[groupSlugs[i]]) return true;
    }
    return false;
  }

  /** True for multi-model combo slugs that must not appear as filter chips. */
  function isComboDisplaySlug(slug) {
    var s = normSlug(slug);
    if (!s) return false;
    if (s === 'iphone x/xs' || s === 'iphone xs/x') return false;
    if (s.indexOf(' / ') !== -1) return true;
    if (parseWatchSizeCombo(s)) return true;
    if (s === 'iphone 12/12 pro' || s === 'airpods 1/2') return true;
    if (/^airpods\s+[\d/]+/.test(s) && s.indexOf('/') !== -1) return true;
    return false;
  }

  function enrichMbfRoot(root) {
    if (!root) return;

    var filterParam = root.dataset.filterParam || DEFAULT_FILTER_PARAM;

    var discovered = [];
    root.querySelectorAll('a.mbf-btn, span.mbf-btn').forEach(function (btn) {
      if (btn.dataset.model) discovered.push(btn.dataset.model);
    });
    if (discovered.length) registerCompatibilitySlugs(discovered);

    var activeSlugs = getActiveFilterSlugs(filterParam);
    var facetCounts = loadFacetCounts(root);
    var facetSlugs = Object.keys(facetCounts);

    root.querySelectorAll('.mbf-brand-body').forEach(function (body) {
      var nodes = Array.prototype.slice.call(body.querySelectorAll('a.mbf-btn, span.mbf-btn'));

      var bodyHasActive = false;

      nodes.forEach(function (btn) {
        var raw = normSlug(btn.dataset.model);
        if (!raw) return;

        if (isComboDisplaySlug(raw)) {
          btn.remove();
          return;
        }

        var group = expandSlugForFilter(raw);
        var comboExtra = [];
        group.forEach(function (g) {
          collectComboContributions(g, facetSlugs).forEach(function (c) {
            if (group.indexOf(c) === -1 && comboExtra.indexOf(c) === -1) comboExtra.push(c);
          });
        });
        if (comboExtra.length) group = group.concat(comboExtra);

        var groupKey = group.join('|');

        var active = isGroupActive(group, activeSlugs);
        if (active) {
          bodyHasActive = true;
        }

        var userModel = getUserModelFromUrl();
        if (!userModel) userModel = readStoredUserModel();
        if (!userModel && active) {
          userModel = resolveUserDisplayModel(null, filterParam);
        }
        if (userModel) userModel = canonicalFacetSlug(userModel);
        var isPrimary = active && userModel && canonicalFacetSlug(raw) === userModel;

        btn.dataset.mbfGroup = groupKey;
        delete btn.dataset.mbfAliases;

        var lbl = btn.querySelector('.mbf-lbl');
        if (lbl) lbl.textContent = formatModelLabel(raw);

        var existingCntEl = btn.querySelector('.mbf-count');
        if (existingCntEl) existingCntEl.remove();

        btn.classList.toggle('active', isPrimary || (active && !userModel));
        btn.classList.toggle('active-compat', active && !!userModel && !isPrimary);

        if (btn.tagName === 'A') {
          var isCollLink = btn.getAttribute('data-mbf-collection-link') === '1';
          var isHub = root.getAttribute('data-mbf-hub') === '1';
          var baseHref = btn.getAttribute('href') || btn.href || window.location.href;
          var crossCollection = false;
          try {
            var hrefUrl = new URL(baseHref, window.location.origin);
            var curPath = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
            var hrefPath = (hrefUrl.pathname || '/').replace(/\/+$/, '') || '/';
            crossCollection = hrefPath !== curPath;
          } catch (_pathErr) { /* ignore */ }

          /* Hub → subcollection links: never rewrite back to hub ?filter=… */
          if ((isHub && isCollLink && !active) || (!active && crossCollection)) {
            /* keep Liquid-provided collection URL */
          } else {
            btn.href = active
              ? buildFilterRemoveHref(baseHref, group, filterParam)
              : buildFilterAddHref(baseHref, group, filterParam);
          }
        }
      });

      /* Liquid's own brand_has_active (collection-filter-device-model-button.liquid)
         only sees whatever compatible_model values Shopify's facet API actually
         returned for mf_filter.values — for collections with hundreds of phone
         models that list is capped/truncated, so a real active model (confirmed
         here, above, via activeSlugs read straight from the URL) can be entirely
         absent server-side and the group renders collapsed with no visual cue
         despite one of its models being the live filter. Fix it up here too, the
         same way the per-button active class/count already gets corrected above. */
      var brandGroup = body.closest('.mbf-brand-group');
      if (brandGroup) {
        var toggle = brandGroup.querySelector('.mbf-brand-toggle');
        if (bodyHasActive) {
          body.classList.remove('collapsed');
          if (toggle) {
            toggle.classList.add('has-active', 'open');
            toggle.setAttribute('aria-expanded', 'true');
          }
        } else if (toggle && toggle.classList.contains('has-active')) {
          /* Only strip a stale has-active (e.g. after clearing the filter) —
             don't collapse a section the user has manually expanded. */
          toggle.classList.remove('has-active');
        }
      }
    });
  }

  function dedupeMbfRoot(root) {
    enrichMbfRoot(root);
  }

  function dedupeRecentLabels(models) {
    var seen = {};
    var out = [];
    (models || []).forEach(function (m) {
      var raw = normSlug(m);
      if (!raw || seen[raw] || isComboDisplaySlug(raw)) return;
      seen[raw] = true;
      out.push(formatModelLabel(raw));
    });
    return out;
  }

  window.AIOO_COMPAT_ALIASES = COMPAT_ALIASES;
  window.AIOO_normalizeModelSlug = normalizeModelSlug;
  window.AIOO_modelsMatch = modelsMatch;
  window.AIOO_modelMatchesSearch = modelMatchesSearch;
  window.AIOO_formatModelLabel = formatModelLabel;
  window.AIOO_dedupeMbfRoot = dedupeMbfRoot;
  window.AIOO_enrichMbfRoot = enrichMbfRoot;
  window.AIOO_dedupeRecentLabels = dedupeRecentLabels;
  window.AIOO_allSlugsForCanonical = allSlugsForCanonical;
  window.AIOO_getCompatibilityGroup = getCompatibilityGroup;
  window.AIOO_expandSlugForFilter = expandSlugForFilter;
  window.AIOO_slugsInSameGroup = slugsInSameGroup;
  window.AIOO_buildFilterAddHref = buildFilterAddHref;
  window.AIOO_buildFilterRemoveHref = buildFilterRemoveHref;
  window.AIOO_isComboDisplaySlug = isComboDisplaySlug;
  window.AIOO_USER_MODEL_PARAM = USER_MODEL_PARAM;
  window.AIOO_getUserModelFromUrl = getUserModelFromUrl;
  window.AIOO_setUserModelParam = setUserModelParam;
  window.AIOO_resolveUserDisplayModel = resolveUserDisplayModel;

  function initMbfRoot(rootId) {
    rootId = rootId || 'mbf-root';
    var root = document.getElementById(rootId);
    if (!root || root.getAttribute('data-mbf-init') === '1') return;
    root.setAttribute('data-mbf-init', '1');

    if (window.AIOO_enrichMbfRoot) window.AIOO_enrichMbfRoot(root);

    var WORD_MAP = {
      iphone: 'iPhone', galaxy: 'Galaxy', samsung: 'Samsung',
      xiaomi: 'Xiaomi', redmi: 'Redmi', poco: 'Poco', mi: 'Mi',
      pixel: 'Pixel', google: 'Google', huawei: 'Huawei', honor: 'Honor',
      nokia: 'Nokia', realme: 'Realme', oneplus: 'OnePlus',
      airpods: 'AirPods', ipad: 'iPad', macbook: 'MacBook', apple: 'Apple',
      lenovo: 'Lenovo', len: 'Lenovo',
      pro: 'Pro', max: 'Max', plus: 'Plus', mini: 'Mini', ultra: 'Ultra',
      se: 'SE', air: 'Air', lite: 'Lite', fe: 'FE', '5g': '5G', nfc: 'NFC',
      edge: 'Edge', note: 'Note', fold: 'Fold', flip: 'Flip', neo: 'Neo',
      xr: 'XR', xs: 'XS', xcover: 'Xcover', '4g': '4G', gen: 'Gen',
      watch: 'Watch', tab: 'Tab'
    };

    function fixLabel(raw) {
      if (window.AIOO_formatModelLabel) return window.AIOO_formatModelLabel(raw);
      var normalized = String(raw || '').toLowerCase().trim();
      return normalized.split(' ').map(function (w) {
        var lw = w.toLowerCase();
        return WORD_MAP[lw] || (w.charAt(0).toUpperCase() + w.slice(1));
      }).join(' ');
    }

    var IPHONE_ORDER = [
      'iphone 18 pro max', 'iphone 18 pro',
    'iphone 17 pro max', 'iphone 17 pro', 'iphone air', 'iphone 17', 'iphone 17e',
      'iphone 16 pro max', 'iphone 16 pro', 'iphone 16 plus', 'iphone 16', 'iphone 16e',
      'iphone 15 pro max', 'iphone 15 pro', 'iphone 15 plus', 'iphone 15',
      'iphone 14 pro max', 'iphone 14 pro', 'iphone 14 plus', 'iphone 14',
      'iphone 13 pro max', 'iphone 13 pro', 'iphone 13', 'iphone 13 mini',
      'iphone 12 pro max', 'iphone 12 pro', 'iphone 12/12 pro', 'iphone 12', 'iphone 12 mini',
      'iphone 11 pro max', 'iphone 11 pro', 'iphone 11',
      'iphone xs max', 'iphone x/xs', 'iphone xr',
      'iphone 8 plus', 'iphone 8', 'iphone 7 plus', 'iphone 7',
      'iphone se 22', 'iphone se 2022', 'iphone se 20', 'iphone se 2020', 'iphone se',
      'iphone 6s plus', 'iphone 6s', 'iphone 6 plus', 'iphone 6/6s', 'iphone 6',
      'iphone 5', 'iphone 2'
    ];
    var IPHONE_MAP = {};
    IPHONE_ORDER.forEach(function (m, i) { IPHONE_MAP[m] = i + 1; });
    if (IPHONE_MAP['iphone air']) IPHONE_MAP['iphone 17 air'] = IPHONE_MAP['iphone air'];
    if (IPHONE_MAP['iphone se 20']) IPHONE_MAP['iphone se 2020'] = IPHONE_MAP['iphone se 20'];
    if (IPHONE_MAP['iphone se 22']) IPHONE_MAP['iphone se 2022'] = IPHONE_MAP['iphone se 22'];
    if (IPHONE_MAP['iphone x/xs']) {
      IPHONE_MAP['iphone x'] = IPHONE_MAP['iphone x/xs'];
      IPHONE_MAP['iphone xs'] = IPHONE_MAP['iphone x/xs'];
      IPHONE_MAP['iphone xs/x'] = IPHONE_MAP['iphone x/xs'];
    }

    function canonicalModelSlug(raw) {
      if (typeof window.AIOO_normalizeModelSlug === 'function') {
        return window.AIOO_normalizeModelSlug(raw);
      }
      var s = String(raw || '').toLowerCase().trim();
      return s === 'iphone 17 air' ? 'iphone air' : s;
    }

    var SUFFIX_WEIGHT = {
      ultra: 60, 'pro max': 55, plus: 50, pro: 45, fe: 35, edge: 34, mini: 33, lite: 25, se: 20
    };

    function modelScore(raw) {
      var s = canonicalModelSlug(raw);
      if (!s) return 0;
      if (IPHONE_MAP[s]) return 100000 - IPHONE_MAP[s];
      if (s.indexOf('galaxy ') === 0 || s.indexOf('samsung ') === 0) {
        var seriesRank = 9;
        if (s.indexOf('galaxy s') === 0 || s.indexOf('samsung s') === 0) seriesRank = 1;
        else if (s.indexOf('galaxy a') === 0 || s.indexOf('samsung a') === 0) seriesRank = 2;
        else if (s.indexOf('galaxy z') === 0 || s.indexOf('samsung z') === 0 || s.indexOf('flip') !== -1 || s.indexOf('fold') !== -1) seriesRank = 3;
        else if (s.indexOf('galaxy note') === 0 || s.indexOf('samsung note') === 0) seriesRank = 4;
        else if (s.indexOf('galaxy m') === 0 || s.indexOf('samsung m') === 0) seriesRank = 5;
        else if (s.indexOf('galaxy j') === 0 || s.indexOf('samsung j') === 0) seriesRank = 6;
        else if (s.indexOf('xcover') !== -1) seriesRank = 7;
        var seriesNums = s.match(/\d+/g) || [];
        var seriesMajor = seriesNums.length ? parseInt(seriesNums[0], 10) : 0;
        var seriesSuffix = 0;
        Object.keys(SUFFIX_WEIGHT).forEach(function (k) {
          if (s.indexOf(k) !== -1) seriesSuffix = Math.max(seriesSuffix, SUFFIX_WEIGHT[k]);
        });
        return (10000 - (seriesRank * 1000)) + (seriesMajor * 10) + (seriesSuffix / 100);
      }
      var nums = s.match(/\d+/g) || [];
      var major = nums.length ? parseInt(nums[0], 10) : 0;
      var suffix = 0;
      Object.keys(SUFFIX_WEIGHT).forEach(function (k) {
        if (s.indexOf(k) !== -1) suffix = Math.max(suffix, SUFFIX_WEIGHT[k]);
      });
      return major * 100 + suffix;
    }

    root.querySelectorAll('a.mbf-btn').forEach(function (a) {
      var raw = a.dataset.model || '';
      var lbl = a.querySelector('.mbf-lbl');
      if (lbl) lbl.textContent = fixLabel(raw);
    });

    root.querySelectorAll('.mbf-brand-body').forEach(function (body) {
      var nodes = Array.prototype.slice.call(body.querySelectorAll('a.mbf-btn'));
      nodes.sort(function (a, b) {
        var sa = modelScore(a.dataset.model);
        var sb = modelScore(b.dataset.model);
        if (sa !== sb) return sb - sa;
        return (a.dataset.model || '').toLowerCase().localeCompare((b.dataset.model || '').toLowerCase());
      });
      nodes.forEach(function (node, i) {
        node.style.order = i;
        body.appendChild(node);
      });
    });

    root.querySelectorAll('[data-mbf-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var brand = this.getAttribute('data-mbf-toggle');
        var bodyEl = document.getElementById(rootId + '-body-' + brand);
        if (!bodyEl) return;
        var isOpen = !bodyEl.classList.contains('collapsed');
        bodyEl.classList.toggle('collapsed', isOpen);
        this.classList.toggle('open', !isOpen);
        this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    var overlayId = 'mbf-loading-' + rootId;
    var overlay = document.getElementById(overlayId);
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = overlayId;
      overlay.className = 'mbf-loading-overlay';
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-label', 'Filtrē...');
      overlay.innerHTML = '<div class="mbf-loading-spinner" aria-hidden="true"></div><span class="mbf-loading-label">Filtrē...</span>';
      document.body.appendChild(overlay);
    }

    root.querySelectorAll('a.mbf-btn, a.mbf-clear-all').forEach(function (a) {
      a.addEventListener('click', function () {
        /* Collection jumps navigate away. The full-screen veil would be
           restored by the back button (bfcache) and freeze the previous page. */
        if (a.getAttribute('data-mbf-collection-link') === '1') return;
        overlay.classList.add('is-active');
      });
    });
  }

  function bootMbfRoots() {
    document.querySelectorAll('.mbf-root[id]').forEach(function (el) {
      initMbfRoot(el.id);
    });
  }

  window.AIOO_initMbfRoot = initMbfRoot;
  window.AIOO_initMbf = function (id) { initMbfRoot(id || 'mbf-root'); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMbfRoots);
  } else {
    bootMbfRoots();
  }
})(window);
